"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreTagsRemoveSyncSlice = void 0;
const get_1 = require("./get.js");
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
exports.coreTagsRemoveSyncSlice = (0, xuder_1.createRemoveSyncSlice)({
    name: name_1.CoreTagsName,
    state: get_1.coreTagsGetAsyncSlice.asyncState,
    transform: (action, state = []) => state.filter((tag) => tag.id !== action.id)
});
//# sourceMappingURL=remove.js.map